export const slaughterItemDtoSlaughterFields = [{
        name: "progressive",
        title: "Progressivo",
        render: (record) => record.slaughterItem.progressive
    }, {
        name: "lotNumber",
        title: "Lotto",
        render: (record) => record.slaughterItem.lotNumber
        /*
        }, {
          name: "srcQuantity",
          title: "Num Capi Ingresso",
          render: (record: ISlaughterItemDTO) => record.slaughterItem.srcQuantity
        */
    }, {
        name: "srcProductTypeName",
        title: "Tipo Ingresso",
        render: (record) => record.srcProductTypeName
        // }, {
        //   name: "dstQuantity",
        //   title: "Quantità uscita",
        //   render: (record: ISlaughterItemDTO) => record.slaughterItem.dstQuantity
    }, {
        name: "dstProductTypeName",
        title: "Tipo Uscita",
        render: (record) => record.dstProductTypeName
    }];
